import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const BackspaceIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 3L7 3C6.31 3 5.77 3.35 5.41 3.88L0 12L5.41 20.11C5.77 20.64 6.31 21 7 21L22 21C23.1 21 24 20.1 24 19L24 5C24 3.9 23.1 3 22 3ZM22 19L7.07 19L2.4 12L7.06 5C7.06 5 7.06 5 7.06 5L22 5L22 19ZM10.41 17L14 13.41L17.59 17L19 15.59L15.41 12L19 8.41L17.59 7L14 10.59L10.41 7L9 8.41L12.59 12L9 15.59Z"
      fill="currentColor"
    />
  </svg>
);

BackspaceIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(BackspaceIcon);
